import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Trash2, RotateCcw } from "lucide-react";
import { euroInt } from "@/lib/format";

const TITLES = {
  models: ["models-trash", "Corbeille des modèles", "Les modèles supprimés sont conservés", "Modèle restauré", "Corbeille"],
  options: ["options-trash", "Corbeille des options", "Les options supprimées sont conservées", "Option restaurée", "Corbeille"],
  expos: ["expos-trash", "Corbeille du stock (occasions et véhicules en stock)", "Les véhicules supprimés du stock sont conservés", "Véhicule remis en stock", "Corbeille du stock"],
};
const RANGE = { van: "Van chevaux", occasion: "Occasion" };

export const OptionsTrash = ({ onRestored, kind = "options" }) => {
  const [tid, title, desc, okMsg, btn] = TITLES[kind];
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!open) return;
    api.get(`/admin/${kind}-trash`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [open, kind]);
  const restore = async (it) => {
    try {
      const { data } = await api.post(`/admin/${kind}-trash/${it.id}/restore`);
      setItems((xs) => xs.filter((x) => x.id !== it.id));
      onRestored?.(data);
      toast.success(okMsg);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <>
      <Button variant="outline" className="gap-1" onClick={() => setOpen(true)} data-testid={`${tid}-btn`}><Trash2 className="w-4 h-4" /> {btn}</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-xl" data-testid={`${tid}-dialog`}>
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>{desc} 30 jours, puis effacés définitivement.</DialogDescription>
          </DialogHeader>
          {items.length === 0 ? <p className="text-sm text-muted-foreground" data-testid={`${tid}-empty`}>La corbeille est vide.</p> : (
            <ul className="divide-y max-h-96 overflow-y-auto">
              {items.map((it) => (
                <li key={it.id} className="py-2 flex items-center gap-3" data-testid={`trash-item-${it.id}`}>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium truncate" title={it.name}>{it.name}</div>
                    <div className="text-xs text-muted-foreground">
                      {RANGE[it.range_key] || "Pro & Sport"}{it.model_name && it.model_name !== it.name ? ` · ${it.model_name}` : ""}{it.country_code ? ` · ${it.country_code}` : ""}{it.owner ? ` · ${it.owner}` : ""}{it.public_ttc != null ? ` · ${euroInt(it.public_ttc)} TTC` : ""} · supprimé le {new Date(it.deleted_at).toLocaleDateString("fr-FR")}{it.deleted_by ? ` par ${it.deleted_by}` : ""}
                    </div>
                  </div>
                  <Button size="sm" variant="outline" className="gap-1" onClick={() => restore(it)} data-testid={`trash-restore-${it.id}`}><RotateCcw className="w-3.5 h-3.5" /> Restaurer</Button>
                </li>
              ))}
            </ul>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
